import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseIntegration";

export default Object.assign(
    {
        apiUrl: "/app",

        async list() {
            const url = this.userUrl({ path: "/" });
            return Vue.http.get(url);
        },

        async listIntegrationsAccessExecution() {
            const url = this.userUrl({ path: "/sending" });
            return Vue.http.get(url);
        },        

        async listIntegrationsCaptiveLogin(type) {
            let path = '/captive-login'

            if(type){
                path += `/${type}`
            }

            const url = this.userUrl({ path });
            return Vue.http.get(url);
        },

        async get(id) {
            const url = this.userUrl({ path: `/${id}` });
            return Vue.http.get(url);
        },

        async find(id) {
            const url = this.userUrl({ path: `${this.url()}/${id}` });
            return await Vue.http.get(url);
        },

        async types() {
            const url = this.url("/types");
            return Vue.http.get(url);
        },

        async typeConfiguration({ type }) {
            const url = this.url(`/type/${type}/config`);
            return Vue.http.get(url);
        },

        async register(form) {
            const url = this.userUrl({ path: `/` });
            return Vue.http.post(url, form);
        },

        async editIntegration({ data, integrationId }) {
            const url = this.userUrl({ path: `/${integrationId}` });
            return Vue.http.put(url, data);
        },

        async configuration(type) {
            const url = this.userUrl({ path: `/hook/configuracao/${type}` });
            return await Vue.http.get(url);
        },

        async persist(data) {
            EventBus.$emit("SHOW_SPINNER");
            const url = this.userUrl();
            const response = await Vue.http.post(url, data).catch((error) => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async remove({ id }) {
            const url = this.userUrl({ path: `/${id}` });

            return Vue.http.delete(url);
        },

        testSend(data) {
            const url = this.userUrl({ path: `/${data._id}/test` });
            return Vue.http.post(url);
        },

        async unset({ interactionId }) {
            const url = this.userUrl({ path: `/interacao/${interactionId}` });
            return Vue.http.delete(url);
        },

        async toggleStatus({ id }) {
            const url = this.userUrl({ path: `/status/${id}` });
            return Vue.http.patch(url);
        },

        async listIntegrationFailedAttempts({id}) {
            const url = this.userUrl({ path: `/${id}/error` });
            return Vue.http.get(url);
        },

        async resendIntegrationFailedAttempts({id}) {
            const url = this.userUrl({ path: `/${id}/error/resend` });
            return Vue.http.post(url);
        },

        async deleteIntegrationFailedAttempts({id}) {
            const url = this.userUrl({ path: `/${id}/error/clear` });
            return Vue.http.delete(url);
        },


    },
    base
);
